var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgSeatThin = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 20,
  height: 21,
  viewBox: "0 0 20 21",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M13.5286 11.7252H9.43982L7.96202 3.98852C7.87413 3.60262 7.64057 3.26632 7.3108 3.05085C6.98103 2.83538 6.58094 2.75765 6.19527 2.83412C5.80959 2.91059 5.46861 3.13526 5.24452 3.46054C5.02044 3.78583 4.93085 4.1862 4.99473 4.57686L6.70033 13.5373C6.76802 13.8852 6.95355 14.1986 7.22523 14.4239C7.49691 14.6493 7.83787 14.7726 8.18982 14.7728H13.5286C13.9298 14.7728 14.3146 14.6123 14.5984 14.3265C14.8821 14.0407 15.0415 13.6532 15.0415 13.249C15.0415 12.8449 14.8821 12.4573 14.5984 12.1715C14.3146 11.8858 13.9298 11.7252 13.5286 11.7252Z",
  stroke: "black",
  strokeMiterlimit: 10
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  d: "M9.7793 11.7134L10.3138 9.9771C10.3138 9.9771 10.4482 9.76915 10.6263 9.6646C10.8044 9.56006 11.172 9.56006 11.172 9.56006H13.7513",
  stroke: "black",
  strokeLinecap: "round",
  strokeLinejoin: "round"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  d: "M7.5 17.7895H11.5625C11.5625 17.7895 12.5 17.7895 13.4375 17.7895C14.375 17.7895 13.4375 16.227 13.4375 16.227L12.6227 14.7727",
  stroke: "black",
  strokeLinecap: "round",
  strokeLinejoin: "round"
})));
export { SvgSeatThin as ReactComponent };